import React, { useEffect, useState, useRef } from "react";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepContent from "@material-ui/core/StepContent";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { useStyles } from "./styles";
import {
  Checkbox,
  Chip,
  FormControl,
  FormControlLabel,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import { Autocomplete } from "@material-ui/lab";
import { getColumData, getHistoricalData, getInstruments, getMarketList } from "apis/download";
import CloseIcon from "@material-ui/icons/Close";
import { marketIncludedColums, excludeTables, tableOrder, historyInstruments } from './constants';
import { NewTable } from "../SelectPredefinedTable/ExporterNewTable";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import { PrimaryButton } from "office-ui-fabric-react";

const contentArray = [
  [
    {
      name: "Intradía",
    },
    {
      name: "Historica",
    },
  ],
];

const getIntradiaSteps = ["Tipo de información", "Mercado", "Instrumentos", "Elige las columnas", "Ordena las columnas"];
const getHistoriaSteps = ["Tipo de información", "Mercado", "Instrumentos", "Campos", "Periodo"];

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
  userSelect: "none",
  display: "flex",
  alignItems: "center",
  margin: `0 0 ${grid}px 0`,
  color: isDragging && "#5e7395",
  fontWeight: isDragging && "bold",
  ...draggableStyle
});

const getListStyle = isDraggingOver => ({
  background: isDraggingOver ? "transparent" : "transparent",
  padding: grid,

});


type Props = {
  setShowSpinner: (showSpinner: boolean) => void;
  onClickMarket: any;
  setColumArr: any;
  rememberCredentials: any;
  addHistoicalDataToTable: any;
  getDownloadHistoryStatus: any;
}

const SideTab = ({ setShowSpinner, onClickMarket, setColumArr, rememberCredentials, addHistoicalDataToTable, getDownloadHistoryStatus }: Props) => {
  const classes = useStyles();

  const [steps, setSteps] = useState(getIntradiaSteps);
  const [activeStep, setActiveStep] = useState<number>(0);
  const [activeStepContent, setActiveStepContent] = useState<any>(contentArray[0]);
  const [autoCompleteData, setAutoCompleteData] = useState<any[]>([]);
  const [selectValue, setSelectValue] = useState(contentArray[0][0].name);
  const [savedValueArray, setSavedValueArray] = useState([]);
  const [chipArray, setChipArray] = useState([]);
  const [marketData, setMarketData] = useState([]);
  const [allMarketData, setAllMarketData] = useState([]);
  const [marketType, setMarketType] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [columData, setColumData] = useState([]);
  const [showColumData, setShowColumData] = useState<any>([{ Name: "Instrumento", IsChecked: true }]);
  const [columSearchText, setColumSearchText] = useState("");
  const [checkAll, setCheckAll] = useState(false);
  const [checkedList, setCheckedList] = useState<any>([{ Name: "Instrumento", Ischecked: true }]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDAte] = useState("");
  const [dataError, setDataError] = useState(false);
  const [finalChecked, setFianlChecked] = useState(true);
  const [openExportNewTable, setOpenExportNewTable] = useState(true);
  const [stateResponse, setStateResponse] = useState("");
  const [orderColumns, setOrderColumns] = useState({
    data: [],
    isActive: false
  });

  const handleNext = async (index) => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);

    if (index === 0) {
      let tempSavedValArr = savedValueArray;
      const val = savedValueArray[index] ? savedValueArray[index] : selectValue
      tempSavedValArr.splice(index, 1, val);
      setSavedValueArray(tempSavedValArr);
      setShowSpinner(true)
      changeMarket();
      setShowSpinner(false);
    }

    setSelectValue("");
    if (index === 1) {
      setChipArray([]);
      const tempArr = savedValueArray.map((item, index) => {
        if (index === 2) {
          return [];
        }
        return item;
      });
      setSavedValueArray(tempArr);
    }


    if (index === 2) {
      setShowSpinner(true)
      if (savedValueArray[0] === "Historica") {
        await fetchHistoricColumData(savedValueArray[1]);
      } else {
        await fetchColumData(chipArray[0].marketTypeId, chipArray[0].valueTypeId, chipArray[0].exchangeId);
      }
      setShowSpinner(false)
    }

    if (index === 3 && savedValueArray[0] === "Intradía") {
      const coloumns = savedValueArray[index].map((item, index) => {
        let id = `${item.Name}-${index}`
        return { id, ...item }
      }).filter((item) => {
        if (item.Name !== "Instrumento") {
          return item
        }
      })

      setOrderColumns({ data: coloumns, isActive: true })
      const tempSavedValArr = savedValueArray;
      tempSavedValArr[index] = [{ Name: "Instrumento", isChecked: true }, ...coloumns]
      setSavedValueArray(tempSavedValArr)

    }
    setActiveStepContent(contentArray[index + 1]);

  };

  const handleBack = (index) => {
    const tempSavedValueArr = savedValueArray;
    setAutoCompleteData([])
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    setActiveStepContent(contentArray[index - 1]);
    tempSavedValueArr.splice(index, 1);
    setSavedValueArray(tempSavedValueArr)
    setColumSearchText("")
    setSelectValue(contentArray[index - 1][0].name);
    setOrderColumns({
      data: [],
      isActive: false
    })
    if (index !== 4) {
      setShowColumData([{ Name: "Instrumento", IsChecked: true }])
      setColumData([{ Name: "Instrumento", IsChecked: true }])
      setCheckAll(false)
      setCheckedList([{ Name: "Instrumento", IsChecked: true }])
    }
    setDate()
  };

  const handleSelectChange = async (event, index) => {
    setSelectValue(event.target.value);
    let tempSavedValArr = savedValueArray;
    tempSavedValArr.splice(index, 1, event.target.value);
    setSavedValueArray(tempSavedValArr);

    if (event.target.value === "Intradía") {
      setSteps(getIntradiaSteps);
    } else if (event.target.value === "Historica") {
      setSteps(getHistoriaSteps);
    }

    if (index === 1) {
      const market = marketData.filter((item) => {
        if (item.name === event.target.value) {
          return item;
        }
      });
      setMarketType(market);
    }
  };

  const handleAutoCompleteChange = async (e, val, index) => {
    const temp = e;
    setSearchText("");
    setAutoCompleteData([]);

    const tempSavedValArr = savedValueArray;
    if (val.length === 0) {
      tempSavedValArr[index] = undefined;
    } else {
      tempSavedValArr[index] = val;
    }
    setSavedValueArray(tempSavedValArr);
    setChipArray(val);
  };

  const handleSearch = (value) => {
    setSearchText(value);
    if (value.length !== 0) {
      fetchInstrumentData(marketType[0].marketId, value);
    }
    if (value.length === 0 || chipArray.length === 0) {
      setAutoCompleteData([])
    }
  };

  const handleChangeColumValue = (e) => {
    const name = e.target.value;
    setColumSearchText(name);
    let tempColumData = columData
      .filter((item) => {
        let itemName = item.Name.toLowerCase();
        if (itemName.includes(name.toLowerCase())) {
          return item;
        }
      })
      .map((x) => {
        let idx = x.Name.toLowerCase().indexOf(name.toLowerCase());
        if (idx >= 0) {
          let newText = [
            x.Name.substring(0, idx),
            x.Name.substring(idx, idx + name.length),
            x.Name.substring(idx + name.length),
          ];
          const obj = {
            ...x,
            newVal: newText,
          };
          return obj;
        }
        return x;
      });

    name === "" ? null : savedValueArray[0] === "Intradía" ? tempColumData.unshift({ Name: "Instrumento", IsChecked: true }) : null;
    setShowColumData(tempColumData);
  };

  const clearText = () => {
    setColumSearchText("");
    setShowColumData(columData);
  };

  const handleInstrumentChange = () => {
  }

  const allSelectedItem = (e) => {
    setColumSearchText("")
    setCheckAll(e.target.checked);
    let tempColumData;
    let tempCheckedList;
    if (e.target.checked === true) {
      tempColumData = columData.map((item) => {
        if (item.Name === "Instrumento" && savedValueArray[0] === "Intradía") {
          return {
            ...item,
            IsChecked: true,
          };
        }
        return {
          ...item,
          IsChecked: true,
        };
      });

      tempCheckedList = tempColumData;

    } else {
      tempColumData = columData.map((item) => {
        if (item.Name === "Instrumento") {
          return {
            ...item,
            IsChecked: true,
          };
        }
        return {
          ...item,
          IsChecked: false,
        };
      });

      savedValueArray[0] === "Intradía" ? tempCheckedList = [{ Name: "Instrumento", IsChecked: true }] : tempCheckedList = []

    }

    let tempSavedValue = savedValueArray;
    tempSavedValue[3] = tempCheckedList;
    setSavedValueArray(tempSavedValue);
    setCheckedList(tempCheckedList);
    setShowColumData(tempColumData);
    setColumData(tempColumData);
  };

  const singleSelectedItem = (e) => {
    const checked = e.target.checked;
    const name = e.target.value;
    const tempShowColumData = showColumData.map((item) => {
      if (name === item.Name) {
        return {
          ...item,
          IsChecked: checked,
        };
      }
      return item;
    });

    const tempColumData = columData.map((item) => {
      if (name === item.Name) {
        return {
          ...item,
          IsChecked: checked,
        };
      }
      return item;
    });

    let tempCheckedList = checkedList;

    if (checked) {
      tempCheckedList.push({ Name: name, IsChecked: true });
    } else {
      tempCheckedList = tempCheckedList.filter((item) => item.Name !== name);
    }


    let tempSavedValue = savedValueArray;
    tempSavedValue[3] = tempCheckedList;
    setCheckedList(tempCheckedList);
    setSavedValueArray(tempSavedValue)
    setShowColumData(tempShowColumData);
    setColumData(tempColumData);
  };

  const handleDateChange = (event, point) => {
    var tempDate;
    if (point === "start") {
      tempDate = [{ startDate: event.target.value }, { endDate: endDate }]
      setStartDate(event.target.value);
    } else {
      tempDate = [{ startDate: startDate }, { endDate: event.target.value }]
      setEndDAte(event.target.value)
    }
    const tempSavedValArr = savedValueArray;
    tempSavedValArr.splice(4, 1, tempDate);
    setSavedValueArray(tempSavedValArr);
  }

  const handleCheckBoxChange = (e) => {
    setFianlChecked(e.target.checked)
  }

  const handleclosesuccess = () => {
    setOpenExportNewTable(true);
    setActiveStep(0);
    setActiveStepContent(contentArray[0])
    setSelectValue(contentArray[0][0].name)
    setSavedValueArray([])
    setChipArray([]);
    setFianlChecked(true);
    setCheckAll(false);
    setShowColumData([{ Name: "Instrumento", IsChecked: true }])
    setCheckedList([{ Name: "Instrumento", IsChecked: true }])
    setAutoCompleteData([]);
    setOrderColumns({
      data: [],
      isActive: false
    })
    setDate()
    setStateResponse("success")
  }

  const addTableToExcel = async (index) => {
    if (index === 4 && savedValueArray[0] === "Historica") {
      await addHistoicalDataToTable(chipArray, startDate, endDate, savedValueArray[3]);
      const downloadStatus = getDownloadHistoryStatus();
      downloadStatus ? setStateResponse("success") : setStateResponse("error");
      setOpenExportNewTable(false);
      setSteps(getIntradiaSteps);

    } else {

      if (savedValueArray[3] === undefined) {
        setColumArr([contentArray[3][0]], false)
      } else {
        const tempDescription = savedValueArray[3].map((item) => {
          return item.Name
        })
        const tempContentArray = contentArray[3];
        let tempSendData = tempContentArray.filter((item) => tempDescription.includes(item["description"])).sort((a, b) => tempDescription.indexOf(a["description"]) - tempDescription.indexOf(b["description"]));

        let mapData = new Map();
        tempSendData.map((item) => mapData.set(item["description"], item))
        tempSendData = Array.from(mapData.values())

        setColumArr(tempSendData, false)
      }
      rememberCredentials(finalChecked)
      let tempSortedInstruments = savedValueArray[2];
      tempSortedInstruments = tempSortedInstruments.sort((a, b) => {
        const name1 = a.symbol.toUpperCase();
        const name2 = b.symbol.toUpperCase();
        let comparison = 0;
        if (name1 > name2) {
          comparison = 1;
        } else if (name1 < name2) {
          comparison = -1;
        }
        return comparison;
      })
      onClickMarket(tempSortedInstruments, savedValueArray[1])
      setOpenExportNewTable(false);
      setStateResponse("success");
    }
  }

  const fetchHistoricColumData = (marketName) => {
    let historicInstruments = historyInstruments.filter((item) => item.name === marketName);
    setColumData(historicInstruments[0].instruments);
    setShowColumData(historicInstruments[0].instruments);
    contentArray[3] = historicInstruments;
  }

  const changeMarket = async () => {
    let arrangeTableOrder;
    let excludeTableId = excludeTables.map((item) => {
      return item.marketId;
    })


    if (savedValueArray[0] === "Historica") {
      excludeTableId = [16, 17, 25, 26];
      arrangeTableOrder = historyInstruments;
      setCheckedList([])

    }
    else {
      arrangeTableOrder = tableOrder;
      setCheckedList([{ Name: "Instrumento", IsChecked: true }])
    }

    let finalTableData = allMarketData["data"].filter((item) => {
      if (!excludeTableId.includes(item.marketId)) {
        return item;
      }
    })

    let finalTableWithOrder = finalTableData.map((item) => {
      let index = arrangeTableOrder.findIndex(x => x.name === item.name);

      return {
        ...item,
        order: index
      }
    })
    finalTableWithOrder = finalTableWithOrder.sort((a, b) => a.order - b.order)
    setMarketData(finalTableWithOrder);
    contentArray[1] = finalTableWithOrder;
  }


  const fetchMarketData = async () => {
    let data = await getMarketList();
    setAllMarketData(data)
    changeMarket()
  };

  const fetchInstrumentData = async (marketId, searchVal) => {
    setShowSpinner(true);
    const instruments = await getInstruments(marketId, searchVal);
    const finalInstrumentsData = instruments.data.filter((item) => {
      if (chipArray.filter((x) => {
        if (x.displaySymbol === item.displaySymbol) {
          if (x.assetClass !== null) {
            if (x.assetClass.exchangeDescription === item.assetClass.exchangeDescription) {
              return x;
            }
          } else {
            return x;
          }
        }
      }).length === 0) {
        return item
      }
    })
    contentArray[2] = finalInstrumentsData;
    setAutoCompleteData(finalInstrumentsData);
    setShowSpinner(false);
  };

  const fetchColumData = async (marketTypeId, valueTypeId, exchangeId) => {
    const arrayUniqueByKey = Array.from(new Map(contentArray[2].map(item =>
      [item["marketTypeId"], item])).values());

    let column;

    column = await getColumData(marketTypeId, valueTypeId, exchangeId);
    if (column.data.length === 0) {
      for (let i = 0; i < arrayUniqueByKey.length; i++) {
        column = await getColumData(arrayUniqueByKey[i]["marketTypeId"], arrayUniqueByKey[i]["valueTypeId"], arrayUniqueByKey[i]["exchangeId"]);
        if (column.data.length > 0) {
          break;
        }
      }
    }

    if (column.data.length > 0) {
      setDataError(true);
    } else {
      setDataError(false)
    }
    const tempIncludeData = marketIncludedColums.filter((item) => marketType[0].marketId === item.marketId).map((x) => x.description)
    const tempArr = column.data.map((item) => {
      if (item.description === "Instrumento") {
        return {
          Name: item.description,
          IsChecked: true,
        };
      }
      return {
        Name: item.description,
        IsChecked: false,
      };
    })

    const finalData = tempArr.filter((item) => tempIncludeData.includes(item.Name))
    setColumData(finalData);
    setShowColumData(finalData);
    contentArray[3] = column.data;
  };

  const setDate = () => {
    const date = new Date();
    const currentDate =
      date.getFullYear() +
      "-" +
      ("0" + (date.getMonth() + 1)).slice(-2) +
      "-" +
      ("0" + date.getDate()).slice(-2);

    setStartDate(currentDate);
    setEndDAte(currentDate);
  }

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const items = reorder(
      orderColumns.data,
      result.source.index,
      result.destination.index
    );

    setOrderColumns({ ...orderColumns, data: items })
    const tempSavedValArr = savedValueArray;
    tempSavedValArr[3] = [{ Name: "Instrumento", IsChecked: true }, ...items];
    setSavedValueArray(tempSavedValArr);
  }


  useEffect(() => {
    fetchMarketData()
    contentArray[2] = [{ name: "instrumento" }]
    contentArray[4] = [{ name: "date" }]
    setDate()
  }, []);

  return (
    <div>
      {
        openExportNewTable ?
          <>
            <div className={classes.moveCardTitle}>Selecciona la información que quieres descargar</div>
            <Stepper className={classes.root} activeStep={activeStep} orientation="vertical">
              {steps.map((label, index) => (
                <Step key={label}>
                  <StepLabel>
                    <Typography>{label}</Typography>
                  </StepLabel>
                  <StepContent>
                    {(index === 0 || index == 1) && (
                      <FormControl variant="filled" className={classes.dropdownLabel} size="small">
                        <InputLabel className={classes.classLabel}>{index === 0 ? <span>Elige</span> : <span>Elige el mercado</span>}</InputLabel>
                        <Select
                          labelId="demo-simple-select-filled-label"
                          id="demo-simple-select-filled"
                          className={classes.select}
                          value={savedValueArray[index] ? savedValueArray[index] : selectValue}
                          onChange={(event) => handleSelectChange(event, index)}
                        >
                          {activeStepContent.map((item, index) => {
                            return (
                              <MenuItem value={item.name} key={index} className={classes.labelItem}>
                                {" "}
                                {item.name}{" "}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    )}

                    {index === 2 && (
                      <>
                        <Autocomplete
                          value={chipArray}
                          id="free-solo-2-demo"
                          multiple
                          limitTags={2}
                          freeSolo={true}
                          options={autoCompleteData}
                          className={classes.searchInstrument}
                          getOptionLabel={(option) => option.displaySymbol}
                          renderOption={(option) => {
                            return <div className={classes.renderDiv}>
                              <div className={classes.leftRenderDiv}>
                                {option.displaySymbol}
                              </div>
                              <div className={classes.rightRenderDiv}>
                                {
                                  option.assetClass !== null && <span>{option.assetClass.exchangeDescription}</span>
                                }
                              </div>

                            </div>
                          }}
                          PaperComponent={({ children }) => <Paper className={classes.option}>{children}</Paper>}
                          defaultValue={chipArray.map((item) => item)}
                          renderTags={(tagValue, getTagProps) =>
                            tagValue.map((option, index) => (
                              <Chip
                                size="small"
                                className={classes.chip}
                                label={option.displaySymbol}
                                {...getTagProps({ index })}
                              />
                            ))
                          }
                          inputValue={searchText}
                          onInputChange={(event, newInputValue) => {
                            const temp = event;
                            if (!newInputValue.startsWith(" ")) {
                              handleSearch(newInputValue);
                            }
                          }}
                          onChange={(e, val) => handleAutoCompleteChange(e, val, index)}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="filled"
                              label="Buscar..."
                              className={classes.searchDropdownLabel}
                              size="small"
                              InputLabelProps={{
                                classes: {
                                  root: classes.ccssLabel,
                                  focused: classes.cssFocused,
                                },
                              }}
                              InputProps={{
                                classes: {
                                  root: classes.cssOutlinedInput
                                },
                                ...params.InputProps,
                              }}
                              placeholder="instrumentos"
                            />
                          )}
                        />

                      </>
                    )}
                    {index === 3 && (
                      <Grid container direction="row" justify="center" alignItems="center">
                        <Grid item xs={12} sm={12} className={classes.columnTitle}>
                          {
                            showColumData.length > 0 ? <>
                              <TextField
                                onChange={(e) => handleChangeColumValue(e)}
                                name="buscar"
                                id="buscar"
                                className={classes.search}
                                value={columSearchText}

                                placeholder="Buscar..."
                                size="small"
                                InputLabelProps={{
                                  classes: {
                                    root: classes.ccssLabel,
                                    focused: classes.cssFocused,
                                  },
                                }}
                                InputProps={{
                                  classes: {
                                    root: classes.cssOutlinedInput,

                                  },
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <SearchIcon className={classes.searchIcon} />
                                    </InputAdornment>
                                  ),

                                  endAdornment: (
                                    <InputAdornment position="end">
                                      {columSearchText.length > 0 && <CloseIcon className={classes.searchIcon} onClick={clearText} />}
                                    </InputAdornment>
                                  )
                                }}
                              />
                              <div style={{ padding: "15px 0 15px 0" }}>
                                <FormControlLabel
                                  name="Seleccionar"
                                  id="Seleccionar"
                                  className={classes.checkBoxLabel}
                                  control={<Checkbox className={classes.checkbox}
                                    checked={checkAll}
                                    onChange={(e) => allSelectedItem(e)}
                                    style={{
                                      transform: "scale(0.7)",
                                      padding: "6px"
                                    }}
                                  />}
                                  label={
                                    <span style={{ fontSize: "13px" }}>
                                      Todas las columnas
                                    </span>
                                  }
                                />

                              </div>
                              <Grid item xs={12} sm={12} className={classes.columnDescName}>
                                <Grid container>
                                  {showColumData.map((columnName, index) => (
                                    <Grid item xs={6} sm={6} key={index} className={classes.SubcolumnDescName}>
                                      {columnName.Name === "Instrumento" ? (
                                        <FormControlLabel
                                          name="Seleccionar"
                                          id="Seleccionar"
                                          className={classes.checkBoxGridLabel}
                                          control={<Checkbox className={classes.checkbox}
                                            checked={true}
                                            onChange={() => handleInstrumentChange()}
                                            style={{
                                              transform: "scale(0.7)",
                                              padding: "6px"
                                            }}
                                            value={columnName.Name}
                                            disabled={true}
                                          />}
                                          label={
                                            <span style={{ fontSize: "13px" }}>
                                              {columnName.Name}
                                            </span>
                                          }
                                        />
                                      ) : (
                                        <FormControlLabel
                                          name="Seleccionar"
                                          id="Seleccionar"
                                          className={classes.checkBoxGridLabel}
                                          control={<Checkbox className={classes.checkbox}
                                            checked={columnName.IsChecked}
                                            onChange={(e) => singleSelectedItem(e)}
                                            style={{
                                              transform: "scale(0.7)",
                                              padding: "6px"
                                            }}
                                            value={columnName.Name}
                                          />}
                                          label={
                                            columnName.hasOwnProperty("newVal") ? (
                                              <>
                                                <span style={{ fontSize: "13px" }}>
                                                  {columnName.newVal[0]}
                                                  <span className={classes.highlightText}>{columnName.newVal[1]}</span>
                                                  {columnName.newVal[2]}
                                                </span>
                                              </>
                                            ) : (
                                              <span style={{ fontSize: "13px" }}>
                                                <>{columnName.Name}</>
                                              </span>

                                            )
                                          }
                                        />
                                      )}
                                    </Grid>
                                  ))}
                                </Grid>
                              </Grid>
                            </> : <h4>Hubo un error, intentalo más tarde</h4>
                          }

                        </Grid>
                      </Grid>
                    )}
                    {
                      index === 4 && savedValueArray[0] === "Intradía" && <>
                        <DragDropContext onDragEnd={onDragEnd}>
                          <Droppable droppableId="droppable">
                            {(provided, snapshot) => (
                              <div
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                                style={getListStyle(snapshot.isDraggingOver)}
                                className={classes.dragListContainer}
                              >
                                <span className={classes.dragContent} style={{ margin: "0px 0px 8px 0px" }}>
                                  <span style={{ color: "grey" }}>{1}</span>  <DragIndicatorIcon className={classes.diableDragbIcon} /> Instrumento
                                </span>
                                {orderColumns.data.map((item, index) => (

                                  <Draggable key={item.id} draggableId={item.id} index={index}>
                                    {(provided, snapshot) => (
                                      <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        style={getItemStyle(
                                          snapshot.isDragging,
                                          provided.draggableProps.style
                                        )}
                                      >
                                        <span className={classes.dragContent}>
                                          <span style={{ color: "rgb(216 216 216)" }}>{index + 2}</span>  <DragIndicatorIcon className={classes.dragIcon} /> {item.Name}
                                        </span>
                                      </div>
                                    )}
                                  </Draggable>
                                ))}
                                {provided.placeholder}
                              </div>
                            )}
                          </Droppable>
                        </DragDropContext>
                      </>
                    }

                    {
                      index === 4 && savedValueArray[0] === "Historica" && <>
                        <Grid container justify-content-evenly="true" alignItems="center">
                          <Grid item xs={5} sm={5}>

                            <TextField
                              type="date"
                              className={classes.datePicker}
                              value={startDate} onChange={(e) => { handleDateChange(e, "start") }}
                              InputProps={{
                                disableUnderline: true
                              }}
                              inputProps={{
                                max: endDate,
                                className: classes.input
                              }}
                            />
                          </Grid>

                          <Grid item xs={1} sm={1}>
                            <Typography align="center">-</Typography>
                          </Grid>

                          <Grid item xs={5} sm={5} >
                            <TextField
                              type="date"
                              className={classes.datePicker}
                              value={endDate}
                              onChange={(e) => { handleDateChange(e, "end") }}
                              InputProps={{
                                disableUnderline: true
                              }}
                              inputProps={{
                                max: endDate,
                                min: startDate,
                                className: classes.input
                              }}
                            />
                          </Grid>
                        </Grid>

                      </>
                    }
                    <div className={classes.actionsContainer}>
                      {
                        activeStep === steps.length - 1 ?
                          <>
                            {
                              (dataError && savedValueArray[0] === "Intradía") &&
                              <div>
                                <FormControlLabel className={classes.checkBoxLabel} control={<Checkbox className={classes.checkbox} checked={finalChecked} onChange={(e) => handleCheckBoxChange(e)} style={{ transform: "scale(0.8)" }} />} label={<span style={{ fontSize: "15px" }}>Mostrar nombres de columnas</span>} />
                              </div>
                            }
                            <PrimaryButton
                              className={savedValueArray[index] || savedValueArray[0] === "Intradía" ? classes.button : index === 3 || index === 4 && dataError ? classes.button : classes.disabledButton}
                              disabled={savedValueArray[index] || savedValueArray[0] === "Intradía" ? false : index === 3 || index === 4 && dataError ? false : true}
                              onClick={() => addTableToExcel(index)}
                            ><span>Exportar</span></PrimaryButton>
                          </>
                          : <PrimaryButton
                            onClick={() => handleNext(index)}
                            className={savedValueArray[index] ? savedValueArray[3]?.length === 0 ? classes.disabledButton : classes.button : index === 0 || (index === 3 && dataError) ? classes.button : classes.disabledButton}
                            disabled={savedValueArray[index] ? savedValueArray[3]?.length === 0 ? true : false : index === 0 || (index === 3 && dataError) ? false : true}
                          ><span>Aceptar</span></PrimaryButton>
                      }
                      {index > 0 && (
                        <PrimaryButton
                          disabled={activeStep === 0}
                          onClick={() => handleBack(index)}
                          className={classes.backButton}
                        >
                          <span>Regresar</span>
                        </PrimaryButton>
                      )}
                    </div>
                  </StepContent>
                </Step>
              ))}
            </Stepper>
          </> : <NewTable handleclose={handleclosesuccess} StateRespone={stateResponse} Opendata={openExportNewTable} ErrorMessage="No hay más información para mostrar." download={true} />
      }

    </div >
  );
};

export default SideTab;



